import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'qs';

import SignupForm from '../../containers/signup/form.container';
import TopNavBar from '../../containers/top-nav-bar.container';

class Signup extends Component {
  constructor(props) {
    super(props);
    this.onSignup = this.onSignup.bind(this);
    this.state = { redirectTo: false };
  }

  onSignup() {
    const query = qs.parse(this.props.location.search.substring(1));

    this.setState({ redirectTo: query.redirect || '/my-groups' });
  }

  redirect() {
    return <Redirect to={this.state.redirectTo} />;
  }

  render() {
    if (this.state.redirectTo) return this.redirect();

    return (
      <div>
        <TopNavBar />
        <div className="row justify-content-center mt-4 pt-4">
          <div className="modal-page">
            <div className="card m-auto">
              <div className="card-block">
                <SignupForm onSignup={this.onSignup} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({ auth }) => ({ auth }))(Signup);



// WEBPACK FOOTER //
// ./src/desktop/components/signup/index.js